import React, { useState } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import Swal from "sweetalert2";
import "../../styles/nav-bar.css";

const Profile = () => {
  let username = "";
  let role = "";

  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decoded = jwtDecode(token);
      username = decoded.username || decoded.sub || "";
      role = decoded.role || "";
    } catch (err) {
      console.error("Invalid token in profile page", err);
    }
  }

  const api_url = process.env.REACT_APP_API_URL;
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      Swal.fire({
        title: "Error",
        text: "New password and confirm password do not match.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${api_url}/api/auth/change-password`,
        { oldPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire({
        title: "Success",
        text: "Your password has been changed successfully.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      });
    } catch (error) {
      Swal.fire({
        title: "Change Password Failed!",
        text:
          error.response?.data?.error ||
          "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
    }
  };

  const initials = username ? username.slice(0, 2).toUpperCase() : "?";

  return (
    <div className="sp-page-wrap">
      <div className="sp-panel">
        {/* Avatar + info row */}
        <div className="sp-avatar-row">
          <div className="sp-avatar">{initials}</div>
          <div>
            <div className="sp-username">{username || "Unknown"}</div>
            <span className="sp-role-badge">{role || "—"}</span>
          </div>
        </div>

        <hr className="sp-divider" />

        <div className="sp-section-label">
          <i className="bi bi-lock me-2"></i>Change Password
        </div>

        <form onSubmit={handleChangePassword}>
          <div className="sp-input-group">
            <label htmlFor="oldPassword">Current Password</label>
            <input
              id="oldPassword"
              type="password"
              className="sp-input"
              placeholder="Enter current password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
          </div>
          <div className="sp-input-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              id="newPassword"
              type="password"
              className="sp-input"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className="sp-input-group">
            <label htmlFor="confirmPassword">Confirm New Password</label>
            <input
              id="confirmPassword"
              type="password"
              className="sp-input"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="sp-btn">
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profile;
